<template>
  <div class="" v-if="tkTaskView.countChild > 0">
    <el-tooltip :content="'Có số công việc con: ' + tkTaskView.countChild">
      <span class="color__green">
        <i class="fas fa-sitemap"></i>
        {{ "(" + tkTaskView.countChild + ")" }}&nbsp;
      </span>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "task-child-tag",
  props: ["tkTaskView"],
  data() {
    return {};
  }
};
</script>



// WEBPACK FOOTER //
// src/views/job/components/task-child-tag.vue